import { Reveal } from "./Reveal";
import { GoogleStars } from "./GoogleStars";

// Shared editorial pull-quote treatment for verified Google reviews.
export const PullQuote = ({ quote, name, testid, big = false, className = "" }) => (
  <Reveal className={className}>
    <blockquote data-testid={testid} className="max-w-2xl">
      <div aria-hidden="true" className="h-px w-12 bg-clay/60 mb-10" />
      <p className={`font-serif italic font-light leading-snug text-ink ${big ? "text-2xl sm:text-3xl lg:text-4xl" : "text-lg sm:text-xl"}`}>
        {quote}
      </p>
      <footer className="mt-6 flex flex-wrap items-center gap-x-3 gap-y-2 text-[11px] tracking-[0.18em] uppercase font-semibold text-smoke">
        — {name}
        <GoogleStars size={10} />
        Google review
      </footer>
    </blockquote>
  </Reveal>
);
